"use strict";

ALKMaps.Control.NetworkSnapping = ALKMaps.Class(ALKMaps.Control.Snapping, {
  considerSnapping: function considerSnapping(point, loc) {
    var best = {
      rank: Number.POSITIVE_INFINITY,
      dist: Number.POSITIVE_INFINITY,
      x: null, y: null,
      _nodeAorB: null,
      _origAttributes: null,
      _tempAttributes: null
    };
    var snapped = false;
    var result, target;
    for (var i = 0, len = this.targets.length; i < len; ++i) {
      target = this.targets[i];
      result = this.testTarget(target, loc);
      if (result) {
        if (this.greedy) {
          best = result;
          best.target = target;
          best._nodeAorB = result._nodeAorB;
          best._origAttributes = result._origAttributes;
          best._tempAttributes = result._tempAttributes;
          snapped = true;
          break;
        } else {
          if (result.rank < best.rank || result.rank === best.rank && result.dist < best.dist) {
            best = result;
            best.target = target;
            best._nodeAorB = result._nodeAorB;
            best._origAttributes = result._origAttributes;
            best._tempAttributes = result._tempAttributes;
            snapped = true;
          }
        }
      }
    }
    if (snapped) {
      var proceed = this.events.triggerEvent("beforesnap", {
        point: point, x: best.x, y: best.y, distance: best.dist,
        layer: best.target.layer, snapType: this.precedence[best.rank]
      });
      if (proceed !== false) {
        point.x = best.x;
        point.y = best.y;
        this.point = point;
        this.point._nodeAorB = best._nodeAorB;
        this.point._origAttributes = best._origAttributes;
        this.point._tempAttributes = best._tempAttributes;
        this.events.triggerEvent("snap", {
          point: point,
          snapType: this.precedence[best.rank],
          layer: best.target.layer,
          distance: best.dist
        });
      } else {
        snapped = false;
      }
    }
    if (this.point && !snapped) {
      point.x = loc.x;
      point.y = loc.y;
      this.point = null;
      this.events.triggerEvent("unsnap", { point: point });
    }
  },

  testTarget: function testTarget(target, loc) {
    var resolution = this.layer.map.getResolution();
    if ("minResolution" in target) {
      if (resolution < target.minResolution) {
        return null;
      }
    }
    if ("maxResolution" in target) {
      if (resolution >= target.maxResolution) {
        return null;
      }
    }
    var tolerance = {
      node: this.getGeoTolerance(target.nodeTolerance, resolution),
      vertex: this.getGeoTolerance(target.vertexTolerance, resolution),
      edge: this.getGeoTolerance(target.edgeTolerance, resolution)
    };
    // this could be cached if we don't support setting tolerance values directly
    var maxTolerance = Math.max(tolerance.node, tolerance.vertex, tolerance.edge);
    var result = {
      rank: Number.POSITIVE_INFINITY, dist: Number.POSITIVE_INFINITY
    };
    var eligible = false;
    var features = target.layer.features;
    var feature, type, vertices, vertex, closest, dist, found;
    var numTypes = this.precedence.length;
    var ll = new ALKMaps.LonLat(loc.x, loc.y);
    for (var i = 0, len = features.length; i < len; ++i) {
      feature = features[i];
      if (feature !== this.feature && !feature._sketch && feature.state !== ALKMaps.State.DELETE && (!target.filter || target.filter.evaluate(feature))) {
        if (feature.atPoint(ll, maxTolerance, maxTolerance)) {
          for (var j = 0, stop = Math.min(result.rank + 1, numTypes); j < stop; ++j) {
            type = this.precedence[j];
            if (target[type]) {
              if (type === "edge") {
                closest = feature.geometry.distanceTo(loc, { details: true });
                dist = closest.distance;
                if (dist <= tolerance[type] && dist < result.dist) {
                  result = {
                    rank: j, dist: dist,
                    x: closest.x0, y: closest.y0, // closest coords on feature
                    _nodeAorB: null,
                    _origAttributes: feature._origAttributes,
                    _tempAttributes: feature._tempAttributes
                  };
                  // console.log(feature);
                  eligible = true;
                  // don't look for lower precedence types for this feature
                  break;
                }
              } else {
                // look for nodes or vertices
                vertices = feature.geometry.getVertices(type === "node");
                found = false;
                for (var k = 0, klen = vertices.length; k < klen; ++k) {
                  vertex = vertices[k];
                  dist = vertex.distanceTo(loc);
                  if (dist <= tolerance[type] && (j < result.rank || j === result.rank && dist < result.dist)) {
                    result = {
                      rank: j, dist: dist,
                      x: vertex.x, y: vertex.y,
                      _nodeAorB: k,
                      _origAttributes: feature._origAttributes,
                      _tempAttributes: feature._tempAttributes
                    };
                    eligible = true;
                    found = true;
                  }
                }
                if (found) {
                  // don't look for lower precedence types for this feature
                  break;
                }
              }
            }
          }
        }
      }
    }
    return eligible ? result : null;
  },

  CLASS_NAME: "ALKMaps.Control.NetworkSnapping"
});


// WEBPACK FOOTER //
// ./app/alkmapsExtension/controlNetworkSnapping.js